module.exports = "/static/images/logo-new-full.svg";